<div class="notification-list-container">
  <div class="notification-list-header">
    <div class="title-container">
      <h3 class="section-title">Notifications</h3>
    </div>
    @if (hasUnread) {
      <button mat-button (click)="markAllAsRead()">
        <span class="mark-all-read-text">Mark all as read</span>
      </button>
    }
  </div>

  @if (dataSource.data.length === 0) {
    <div class="notification-empty-state">
      <mat-icon class="empty-icon">notifications_none</mat-icon>
      <p>No notifications at this time</p>
    </div>
  } @else {
    <div class="notification-table-wrapper">
      <table mat-table [dataSource]="dataSource" matSort class="notification-table table-unread-state">
        <!-- Title Column -->
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
          <td mat-cell *matCellDef="let notification" [class.unread-text]="!notification.isRead">
            {{ notification.title }}
          </td>
        </ng-container>

        <!-- Message Column -->
        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef>Message</th>
          <td mat-cell *matCellDef="let notification"
              [innerHTML]="getDisplayMessage(notification)"
              (click)="onMessageClick($event, notification)">
          </td>
        </ng-container>

        <!-- Date Column -->
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc">Date</th>
          <td mat-cell *matCellDef="let notification">
            {{ notification.createdAt | date:'MMM d, y h:mm a' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"
            [class.unread-row]="!row.isRead"
            [class.clickable-row]="!row.isRead"
            (click)="onRowClick(row)"></tr>
      </table>
    </div>

    <mat-paginator
      [length]="dataSource.data.length"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 25]"
      showFirstLastButtons
      aria-label="Select page of notifications"
    ></mat-paginator>
  }
</div>
